/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSessionUrlRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  port?: number | null | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSessionUrlRequest$inboundSchema: z.ZodType<
  GetSessionUrlRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  port: z.nullable(z.number().int()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSessionUrlRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  port?: number | null | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSessionUrlRequest$outboundSchema: z.ZodType<
  GetSessionUrlRequest$Outbound,
  z.ZodTypeDef,
  GetSessionUrlRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  port: z.nullable(z.number().int()).optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSessionUrlRequestToJSON(
  getSessionUrlRequest: GetSessionUrlRequest,
): string {
  return JSON.stringify(
    GetSessionUrlRequest$outboundSchema.parse(getSessionUrlRequest),
  );
}
export function getSessionUrlRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSessionUrlRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSessionUrlRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSessionUrlRequest' from JSON`,
  );
}
